import React from 'react';
import PropTypes from 'prop-types';
import Tippy from '@tippyjs/react/headless';

export default class Tooltip extends React.Component {
  static propTypes = {
    content: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.object]),
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.object, PropTypes.array]),
    className: PropTypes.string,
    contentClassName: PropTypes.string,
    placement: PropTypes.string,
    delay: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.arrayOf(PropTypes.number),
    ]),
    offset: PropTypes.arrayOf(PropTypes.number),
    appendTo: PropTypes.func,
  }

  static defaultProps = {
    contentClassName: '',
    placement: undefined,
    delay: undefined,
    offset: undefined,
    appendTo: undefined,
  }

  render() {
    const {
      content,
      children,
      className,
      contentClassName,
      placement,
      delay,
      offset,
      appendTo,
    } = this.props;

    return (
      <Tippy
        placement={placement}
        delay={delay}
        offset={offset}
        appendTo={appendTo}
        render={attrs => (
          <div
            className={`tooltip xxsm-font padding-5 light bg-dark border-radius-4 ${contentClassName}`}
            tabIndex="-1"
            {...attrs}
          >
            {content}
          </div>
        )}
      >
        <div className={className}>
          {children}
        </div>
      </Tippy>
    )
  }
}
